import { render, staticRenderFns } from "./ArmsEditor.vue?vue&type=template&id=11a11ffa"
import script from "./ArmsEditor.vue?vue&type=script&lang=js"
export * from "./ArmsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports